import { render, staticRenderFns } from "./BrandError.vue?vue&type=template&id=37d41ae3&scoped=true&"
import script from "./BrandError.vue?vue&type=script&lang=js&"
export * from "./BrandError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d41ae3",
  null
  
)

export default component.exports